import { History } from 'history';

class RlNavigation {
  history!: History<History.PoorMansUnknown>;

  set(history: History<History.PoorMansUnknown>) {
    this.history = history;
  }

  async push(u: string) {
    if (this.history) {
      this.history.push(u);
    }
  }

  path() {
    if (this.history) {
      return this.history.location.pathname;
    }

    return '';
  }
}

export const rlNavigation = new RlNavigation();
